<template>
  <div class="history">
    <div>
      <div class="title">
        {{ isShowAll ? $t('profile.allRecords') : $t('profile.recent7Days') }}
      </div>
      <el-scrollbar max-height="500px">
        <el-card class="box-card">
          <div
            v-for="item in recentHistories"
            :key="item.conceptId"
            class="list-item"
            @click="showDetail(item.conceptId)"
          >
            <div>{{ item.preferredName }}</div>
            <div>{{ item.conceptId }}</div>
          </div>
          <div v-if="recentHistories.length === 0">
            <el-empty
              :image-size="50"
              :description="$t('profile.noData')"
            ></el-empty>
          </div>
        </el-card>
      </el-scrollbar>
    </div>
    <div v-if="!isShowAll">
      <div class="title">{{ $t('profile.earlier') }}</div>
      <el-scrollbar max-height="500px">
        <el-card class="box-card">
          <div
            v-for="item in restHistories"
            :key="item.conceptId"
            class="list-item"
            @click="showDetail(item.conceptId)"
          >
            <div>{{ item.preferredName }}</div>
            <div>{{ item.conceptId }}</div>
          </div>
          <div v-if="restHistories.length === 0">
            <el-empty
              :image-size="50"
              :description="$t('profile.noData')"
            ></el-empty>
          </div>
        </el-card>
      </el-scrollbar>
    </div>
    <div class="browsing-history">{{ $t('profile.browseHistory') }}</div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import router from '@/router'
import { browsedHistory } from '@/api/profile'

export default defineComponent({
  props: {
    userInfoList: {
      type: Object,
      default: () => ({}),
    },
  },
  setup() {
    const store = useStore()
    const recentHistories = ref([] as any)
    const restHistories = ref([] as any)
    const isShowAll = ref(false)
    const asyncGetBrowsedHistory = async () => {
      const res = await browsedHistory()
      if (res.status) {
        recentHistories.value = res.data.recentHistories
        restHistories.value = res.data.restHistories
        if (
          res.data.restHistories.length === 0 ||
          res.data.recentHistories.length === 0
        ) {
          isShowAll.value = true
          recentHistories.value =
            res.data.recentHistories.length > 0
              ? res.data.recentHistories
              : res.data.restHistories
        }
      }
    }
    const showDetail = (conceptId: string) => {
      const dataSourceName = (
        document.getElementById('dicName') as HTMLInputElement
      ).value
      const item = store.state.dataSourceList.filter(
        (item) => item.describe === dataSourceName
      )[0]
      router.push(`/conceptDetail/${conceptId}/${item.name}/${item.version}`)
    }
    onMounted(() => {
      asyncGetBrowsedHistory()
    })
    return {
      showDetail,
      store,
      asyncGetBrowsedHistory,
      recentHistories,
      restHistories,
      isShowAll,
    }
  },
})
</script>
<style lang="less" scoped>
.history {
  display: flex;
  flex-flow: column;
  margin-bottom: 80px;
  .title {
    margin-top: 40px;
    margin-bottom: 20px;
    font-size: 20px;
    color: #c0c4cc;
    font-weight: bold;
  }

  .box-card {
    border: none;
    .list-item {
      display: flex;
      justify-content: space-between;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #dcdfe6;
      font-weight: 600;
      cursor: pointer;
      padding: 0px 10px;
    }
    .list-item:hover {
      background: #f9f9f9;
      color: #0ca1bd;
    }
  }

  .browsing-history {
    font-size: 15px;
    line-height: 30px;
    text-align: center;
    color: #dcdfe6;
    position: relative;
    margin: 100px 0px 40px 0px;
  }
  .browsing-history::before {
    content: '';
    width: 40px;
    margin-left: -45px;
    margin-top: 15px;
    border-top: 1px solid #dce0e6;
    position: absolute;
  }
  .browsing-history::after {
    content: '';
    width: 40px;
    margin-left: 5px;
    margin-top: 15px;
    border-top: 1px solid #dce0e6;
    position: absolute;
  }
}
.mobile-viewport {
  .history {
    .title {
      font-size: 16px;
      margin-top: 20px;
    }
    .browsing-history {
      font-size: 13px;
    }
  }
}
</style>

